import Client from './Client';

const AdminStatsApi = {
    get: async () => {
        return await Client.get('/v1/admin/stats');
    },
};

export default AdminStatsApi;
